import React from "react";
import { Select, Divider, Box } from '@mantine/core';

import InputWrapperCustom from "../general/InputWrapperCustom";
import BarangFormCekDetilQCDibatalkan from "./BarangFormCekDetilQCDibatalkan";

const BarangFormCekQCDibatalkan = ({ stateData }) => {

    return (
        <React.Fragment>
            <InputWrapperCustom
                stateLabel={stateData.data.label}
                stateWithAsterisk={stateData.data.withAsterisk}
                stateError={stateData.data.error}
                stateDescription={stateData.data.description}
            >
                <Select
                    disabled
                    readOnly
                    defaultValue={stateData.data.value.masterId}
                    data={[
                        { value: '', label: 'Tidak ada data' },
                        ...stateData.dataBarangFormCek.map(key => ({ value: key.barang_form_cek_id, label: key.barang_form_cek_name }))
                    ]}

                    styles={(tema) => ({
                        input: {
                            backgroundColor: `${tema.colorScheme === 'light' ? '#fff' : tema.colors.dark[7]} !important`,
                            opacity: `1 !important`
                        }
                    })}
                />
            </InputWrapperCustom>

            <Box
                mt={(Array.isArray(stateData.data.value.detil) && stateData.data.value.detil.length > 0) ? 'xl' : 0}
            >
                {(Array.isArray(stateData.data.value.detil) && stateData.data.value.detil.length > 0) && Object.keys(stateData.data.value.detil).map((key, index) => {
                    return (
                        <Box
                            key={key}
                            mt='md'
                        >
                            <BarangFormCekDetilQCDibatalkan
                                stateData={stateData.data.value.detil[key]}
                            />

                            {(Number(index) + 1) !== stateData.data.value.detil.length && <Divider mt='md' />}
                        </Box>
                    )
                })}
            </Box>
        </React.Fragment>
    )
}

export default BarangFormCekQCDibatalkan;